// The ECMAScript lib definitions fed to the Monaco editor for filter-code
// IntelliSense. We register the `lib.*.d.ts` files from the installed
// TypeScript package (keyed by their real filename) so the editor resolves the
// `/// <reference lib=... />` directives between them and matches the ES2024
// surface the runtime compiler accepts. This must include the non-`es<year>`
// files the chain references (e.g. lib.decorators*.d.ts, which lib.es5.d.ts
// references). Excluded:
//   - the DOM/worker/scripthost libs and the `*.full.d.ts` + `lib.d.ts`
//     umbrellas (all DOM-bearing — filter code has no DOM)
//   - `lib.esnext.*` (unratified proposals the runtime compiler won't accept)
//
// This mirrors `loadAllTsLibs()` in runtime_scripting_lambdas; keep the two in
// sync when bumping the TypeScript version.
const modules = import.meta.glob("/node_modules/typescript/lib/lib.*.d.ts", {
  query: "?raw",
  import: "default",
  eager: true,
})

const esLibDefs = {}
for (const [filePath, source] of Object.entries(modules)) {
  const filename = filePath.split("/").pop()
  if (
    filename === "lib.d.ts" ||
    filename.includes(".full.") ||
    /^lib\.(dom|webworker|scripthost|esnext)/.test(filename)
  ) {
    continue
  }
  esLibDefs[filename] = source
}

export default esLibDefs
